'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var routes = [
// 
{
  path: '/vip',
  component: function component() {
    return import('@views/entry/index.vue');
  },
  name: 'vip',
  meta: {
    auth: ['anon'],
    group: 'entry',
    title: ''
  }
},
// 注册主页
{
  path: '/register',
  component: function component() {
    return import('@views/entry/register/index.vue');
  },
  name: 'register',
  meta: {
    auth: ['anon'],
    group: 'entry',
    title: '注册会员'
  }
},
// 登录
{
  path: '/login',
  component: function component() {
    return import('@views/entry/login.vue');
  },
  name: 'login',
  meta: {
    auth: ['anon'],
    group: 'entry',
    title: '登录'
  }
},
// 恢复密码
{
  path: '/recovery',
  component: function component() {
    return import('@views/entry/recovery.vue');
  },
  name: 'recovery',
  meta: {
    auth: ['anon'],
    group: 'entry',
    title: '恢复密码'
  }
}];

exports.default = routes;


//////////////////
// WEBPACK FOOTER
// ./src/router/entry.js
// module id = 586
// module chunks = 14